import request from "./request";

const ReviewQuizMCQExamService = {
    Get: async (id, context, signal) => {
        return await request.sendRequest(`/reviewquizmcqexam/${id}`, context.token, signal);
    },
    GetByExam: async (id, context, signal) => {
        return await request.sendRequest(`/reviewquizmcqexam/exam/${id}`, context.token, signal);
    },
};

export default ReviewQuizMCQExamService;
